import Item from '../common/item'

const state = Object.assign({}, Item.state)
state.endpoint = 'directory'

export default {
  namespaced: true,
  state,
  getters: Item.getters,
  mutations: Item.mutations,
  actions: Item.actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/directory/directory.js